import type { MRT_ColumnDef } from "mantine-react-table-open";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getGreenByteColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "ID", accessorKey: "parameters.greenbyteId" },
    { header: "Name der Liegenschaft", accessorKey: "parameters.siteName" },
    { header: "Titel", accessorKey: "parameters.title" },
    { header: "Alternativer Titel", accessorKey: "parameters.altTitle" },
    {
      header: "Datum der Installation",
      accessorKey: "parameters.installationDate",
      size: 150,
      sortingFn: (rowA, rowB) =>
        "installationDate" in rowA.original.parameters &&
        "installationDate" in rowB.original.parameters
          ? sortBackendDates(
              rowA.original.parameters.installationDate,
              rowB.original.parameters.installationDate
            )
          : 0,
      Cell: ({ renderedCellValue }) => renderedCellValue || "Unbekannt"
    }
  ];
}

export { getGreenByteColumns };
